import moment from 'moment'
import { ConversationAPI, json } from '@driftt/dapper'
import { ConversationAPIAuthEnabled } from 'app/auth-requests/api'

import Qs from 'qs'

export const fetchPlaybooks = async (
  tableState = 'CHAT_ACTIVE',
  nameQuery = null,
  sort = { dir: 'asc', property: 'priority' },
  { page = 0, pageSize = 10 },
  onlyMine = false
) => {
  const params = {
    category: tableState,
    sortDirection: sort.dir,
    sortProperty: sort.property,
    page,
    pageSize,
    onlyMine,
    includeMetrics: false,
  }
  if (!!nameQuery)
    params.nameQuery = nameQuery
  const query = Qs.stringify(params)
  return ConversationAPIAuthEnabled
    .get(`/playbooks/page?${query}`)
    .then(res => res.data)
}

export const getMetricsForPlaybook = async (playbookId, startDate, endDate) => {
  const momentFormat = 'YYYY-MM-DD'
  const queryParams = Qs.stringify({
    playbookIds: playbookId,
    startDate: moment(startDate).format(momentFormat),
    endDate: moment(endDate).format(momentFormat)
  })
  return ConversationAPIAuthEnabled
    .get(`/playbooks/metrics?${queryParams}`)
    .then(res => res.data)
}

export const fetchPrioritizedPlaybooks = async () => {
  return ConversationAPI.get(`/playbooks?status=ENABLED&status=DISABLED`).then(json)
}

export const createNewSalesSequencePlaybook = async () => {
  return ConversationAPI.post(`/playbooks?type=OUTBOUND_SEQUENCE`).then(json)
}

export const savePriorities = async playbookList => {
  return ConversationAPI.patch(`/playbooks/reorder`, playbookList).then(json)
}

export const fetchCategoryCount = async (onlyMine = false) => {
  const params = {
    onlyMine,
  }
  const query = Qs.stringify(params)
  return ConversationAPI.get(`/playbooks/category-counts?${query}`).then(json)
}

export const updateStatus = async playbook => {
  return ConversationAPI.patch(`/playbooks/${playbook.id}/${playbook.status}`).then(json)
}

export const archivePlaybookById = async playbookId => {
  return ConversationAPI.patch(`/playbooks/${playbookId}/ARCHIVED`).then(json)
}

export const disablePlaybookById = async playbookId => {
  return ConversationAPI.patch(`/playbooks/${playbookId}/DISABLED`).then(json)
}

export const clonePlaybookById = async playbookId => {
  return ConversationAPI.post(`/playbooks/${playbookId}/clone`).then(json)
}

export const clonePlaybookAsLandingPage = async playbookId => {
  return ConversationAPI.post(`/playbooks/${playbookId}/clone_as_landing_page`).then(json)
}

export const clonePlaybookAsBot = async playbookId => {
  return ConversationAPI.post(`/playbooks/${playbookId}/clone_as_bot_playbook`).then(json)
}

export const deletePlaybookById = async playbookId => {
  return ConversationAPI.patch(`/playbooks/${playbookId}/DELETED`).then(json)
}



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/api/playbooks.js